'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import useAccountQuery from '@/hooks/useAccountQuery';
import { getJWT } from '@/services/jwt';

export function usePartnerAccountRedirect() {
  const router = useRouter();
  const account = useAccountQuery({
    enabled: !!getJWT()
  });

  useEffect(() => {
    const accountData = account.data?.data;
    const hasOrganization = !!accountData?.organization;

    if (accountData && hasOrganization) {
      router.push('/partner/dashboard');
    }
  }, [account.data, router]);

  return account;
}
